import { Injectable } from '@angular/core';
import * as singalR from "@microsoft/signalr";
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})

export class SignalRService {

  private hubConnection: singalR.HubConnection;
  private readonly addtoGroupMethod: string = "AddToGroup";
  private readonly statusListener: string = "deliveryStatus";
  private readonly productsListener: string = "updatedProducts";

  public startConnection = () => {
    this.hubConnection = new singalR.HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/${this.statusListener}`)
      .withAutomaticReconnect()
      .build();
  }

  public startConnectionWithProducts = () => {
    this.hubConnection = new singalR.HubConnectionBuilder()
      .withUrl(`${environment.apiUrl}/${this.productsListener}`)
      .withAutomaticReconnect()
      .build();
  }

  public addToGroupWithStart(groupName: string) {
    this.hubConnection.start().then(
      () => {
        this.hubConnection.invoke(this.addtoGroupMethod, groupName);
      })
      .catch(err => {
        console.log(err);
      });
  }

  public getHubConnection(): signalR.HubConnection {
    return this.hubConnection;
  }

  constructor() { }
}
